import React from 'react';

import PreBetRoundPreview from '../PreBetRoundPreview';

function WaitingRoomContent({ viewProps }) {
  return <PreBetRoundPreview viewProps={viewProps} />;
}

export default WaitingRoomContent;
